import axios from "axios";
import type {
  AiApiErrorCode,
  AiApiErrorResponse,
  ParentAssistantMessage,
} from "@/lib/api-types";

const LIMIT_CODES = new Set<AiApiErrorCode>([
  "RATE_LIMITED_DAILY",
  "RATE_LIMITED_MONTHLY",
  "RATE_LIMITED_YEARLY",
  "AI_BUDGET_EXHAUSTED",
]);

const RETRYABLE_CODES = new Set<AiApiErrorCode>([
  "UPSTREAM_BUSY",
  "UPSTREAM_ERROR",
]);

export function getAiErrorDetails<TMessage = ParentAssistantMessage>(
  error: unknown,
): AiApiErrorResponse<TMessage> | null {
  if (!axios.isAxiosError<AiApiErrorResponse<TMessage>>(error)) return null;
  const data = error.response?.data;
  return data?.code ? data : null;
}

export function isAiLimitError(error: unknown): boolean {
  const details = getAiErrorDetails(error);
  return Boolean(details && LIMIT_CODES.has(details.code));
}

export function isRetryableAiError(error: unknown): boolean {
  const details = getAiErrorDetails(error);
  return Boolean(details && RETRYABLE_CODES.has(details.code));
}
